export default  {	
	data () {
		return {

		}
	},
	created () { 
		this.updateCrud({state:'namePath', data: 'paciente_garantias'}) 
	},
}
